import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import getStore from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import parseConnect from './util/connect';
import { getI18n } from './util/i18n';
import { getBaseDomain } from './util/path';
import { createTimer } from './util/timer';
import { getConnectionArg } from './features/init/initSlice';
import ReactGA from 'react-ga';

const root = document.getElementById('root');
const connectStr = root.getAttribute('data-connect');
const connectArgs = parseConnect(connectStr);

const store = getStore(connectArgs);
getI18n(connectArgs, store);
createTimer(store);

if (process.env.NODE_ENV === "production") {
  const gaID = getConnectionArg(store.getState(), 'gaID');
  ReactGA.initialize(
    gaID,
    { gaOptions: { cookieDomain: getBaseDomain(window.location.hostname) } }
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  root
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
